import '../App.css';
import { useEffect, useMemo, useState } from 'react';
import throttle from 'lodash/throttle';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { styled } from '@mui/material/styles';
import { DataGrid, GridColDef, GridEventListener, GridEventLookup } from '@mui/x-data-grid';
import Link from '@mui/material/Link';

import { binary_search, gameTypesAvailable, mapTypeAvailable } from '../util';
import { AnalysisPlayerResignInterface } from '../types';

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

var columnsPlayerResign: GridColDef[] = [
  { field: 'id', headerName: '', width: 50,
    renderCell: (params) => {
      return params.api.getRowIndex(params.row.id) + 1;
    },
  },
  { field: 'player', headerName: 'Player', width: 150,
    renderCell: (params) => {
      return (
        <Link target="_blank" href={`http://zero-k.info/Users/Detail/${params.value.id}`}>{params.value.nickname}</Link>
        )
    },
  },
  { field: 'teamWonWhenResigned', headerName: 'Team Won When Resigned %', width: 250,
    renderCell: (params) => {
      return params.value;
    },
  },
  { field: 'teamLostWhenResigned', headerName: 'Team Lost When Resigned %', width: 250,
    renderCell: (params) => {
      return params.value;
    },
  },
  { field: 'overalResigned', headerName: 'Overall resign %', width: 150,
    renderCell: (params) => {
      return params.value;
    },
  },
  { field: 'resignCount', headerName: 'Resign Count', width: 130,
    renderCell: (params) => {
      return params.value;
    },
  },
  { field: 'battleCount', headerName: 'Battle Count', width: 130,
    renderCell: (params) => {
      return params.value;
    },
  },
  { field: 'teamWonWhenResignedPercentageSum', headerName: 'Avg played when team won %', width: 250,
    renderCell: (params) => {
      return params.value;
    },
  },
  { field: 'teamLostWhenResignedPercentageSum', headerName: 'Avg played when team lost %', width: 250,
    renderCell: (params) => {
      return params.value;
    },
  },];

  var columnsBattlesPlayerResign: GridColDef[] = [
    { field: 'id', headerName: '', width: 50,
      renderCell: (params) => {
        return params.api.getRowIndex(params.row.id) + 1;
      },
    },
    { field: 'battle_date', headerName: 'Date', width: 100,
      renderCell: (params) => {
        const d =  new Date(params.value*1000);
        return d.getFullYear() + "-" + (d.getMonth()+1) + "-" + d.getDate();
      },
    },
    { field: 'id', headerName: 'Battle URL', width: 120,
      renderCell: (params) => {
        return (
          <Link target="_blank" href={`http://zero-k.info/Battles/Detail/${params.value}?ShowWinners=True`}>Battle link</Link>
        )
      },
    },
    { field: 'won', headerName: 'Won', width: 100,
      renderCell: (params) => {
        return params.value?"True":"False";
      },
    },
    { field: 'playedPercent', headerName: 'Played (%)', width: 150,
      renderCell: (params) => {
        return params.value;
      },
    },
    { field: 'playedTime', headerName: 'Played (sec)', width: 150,
      renderCell: (params) => {
        return params.value;
      },
    },
    { field: 'battleDuration', headerName: 'Duration (sec)', width: 120,
      renderCell: (params) => {
        return params.value;
      },
    },
  ];

interface DataPlayerResignType {
  teamWonWhenResigned: number,
  teamWonWhenResignedPercentageSum: number,
  teamLostWhenResigned: number,
  teamLostWhenResignedPercentageSum: number,
  battleCount: number,
}
interface RowPlayerResignType extends DataPlayerResignType {
  id: number,
  player: {id: number, nickname: string},
  overalResigned: number,
  resignCount: number,
}

type PlayerBattleListType = Array<{
  id: number,
  battle_date: number,
  won: boolean,
  playedPercent: number,
  playedTime: number,
  battleDuration: number,
}>;
function PlayerResign(props: AnalysisPlayerResignInterface) {
  const filterBar = props.filterBarValues;

  const [rowsPlayerResign, setRowsPlayerResign] = useState<RowPlayerResignType[]>([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<PlayerBattleListType|null>(null);

  const [minimumGamesDisplay, setMinimumGamesDisplay] = useState(0);
  const [maximumGames, setMaximumGames] = useState(1000);
  const [countGames, setCountGames] = useState(1000);


  const computeDataPlayerResign = (playerIdForList:number|null) => {
    var i;

    const jsonBattles_min = binary_search(props.jsonBattles.started_sec, (filterBar.startDate/1000), false, true);
    const jsonBattles_max = binary_search(props.jsonBattles.started_sec, (filterBar.endDate/1000), true, false);

    var playerBattleList:PlayerBattleListType = [];

    // Dictionary with keys player id-s and values a dictionary with keys:
    // teamWonWhenResigned
    // teamWonWhenResignedPercentageSum
    // teamLostWhenResigned
    // teamLostWhenResignedPercentageSum
    // battleCount
    var dataPlayerResign:{[index:number]:DataPlayerResignType} = {};

    var gamesIds = filterBar.gamesChecked;

    var count_battles = 0;

    for(i=jsonBattles_min; i<=jsonBattles_max; i++) {
      var gameTypeOk = false;
      var j;
      for(j=0;j<filterBar.gameTypesChecked.length;j++) {
        if(filterBar.gameTypesChecked[j] && gameTypesAvailable[j].func_filter(props.jsonBattles,i)) {
          gameTypeOk = true;
          break;
        }
      }
      if(!gameTypeOk) {
        continue;
      }

      if(!gamesIds.includes(props.jsonBattles.game_id[i])) {
        continue;
      };

      const map_idx = binary_search(props.jsonMaps.map_id, props.jsonBattles.map_id[i]);

      if(!filterBar.mapTypeAvailableChecked.map((elem, j) =>
          (!elem || mapTypeAvailable[j]['value'] === props.jsonMaps[mapTypeAvailable[j]['column']][map_idx])).every((x)=>x)) {
            continue;
      }
      var area = props.jsonMaps.size_x[map_idx]*props.jsonMaps.size_y[map_idx];
      if(area<filterBar.mapSize[0] || filterBar.mapSize[1]<area) {
        continue;
      }

      const battle_player_idx_first = binary_search(props.jsonBattlePlayer.battle_id, props.jsonBattles.battle_id[i], true, false, true);

      var playersFound = false;
      var battle_player_idx = battle_player_idx_first;
      while(props.jsonBattlePlayer.battle_id[battle_player_idx] === props.jsonBattles.battle_id[i]) {
        const battle_player_id = props.jsonBattlePlayer.player_id[battle_player_idx];
        if (battle_player_id === filterBar.playerId) {
          playersFound = true;
        }
        battle_player_idx++;
      }

      if (filterBar.playerId && !playersFound) {
        continue;
      }

      // Either we do not filter only battles with specific player, or that
      // player is in, so count all measurs
      battle_player_idx = battle_player_idx_first;
      while(props.jsonBattlePlayer.battle_id[battle_player_idx] === props.jsonBattles.battle_id[i]) {
        const battle_player_id = props.jsonBattlePlayer.player_id[battle_player_idx];
        if (!(battle_player_id in dataPlayerResign)) {
          dataPlayerResign[battle_player_id] = {
            teamWonWhenResigned: 0,
            teamWonWhenResignedPercentageSum: 0,
            teamLostWhenResigned: 0,
            teamLostWhenResignedPercentageSum: 0,
            battleCount: 0,
          };
        }

        const player_team = props.jsonBattlePlayer.team_id[battle_player_idx];
        if(props.jsonBattlePlayer.playtime_sec[battle_player_idx]!= props.jsonBattles.duration_sec[i]) {
          // Player did resign
          var won;
          if (props.jsonBattlePlayer.team_id[battle_player_idx] === props.jsonBattles.team_won[i]) {
            won = true;
            dataPlayerResign[battle_player_id].teamWonWhenResigned++;
            dataPlayerResign[battle_player_id].teamWonWhenResignedPercentageSum += props.jsonBattlePlayer.playtime_sec[battle_player_idx]/props.jsonBattles.duration_sec[i];
          } else {
            won = false;
            dataPlayerResign[battle_player_id].teamLostWhenResigned++;
            dataPlayerResign[battle_player_id].teamLostWhenResignedPercentageSum += props.jsonBattlePlayer.playtime_sec[battle_player_idx]/props.jsonBattles.duration_sec[i];
          }

          if (playerIdForList!==null && playerIdForList==props.jsonBattlePlayer.player_id[battle_player_idx]) {
            // Add the battle to the player list
            playerBattleList.push({
              id: props.jsonBattles.battle_id[i],
              battle_date: props.jsonBattles.started_sec[i],
              won: won,
              playedPercent: Number(Number(props.jsonBattlePlayer.playtime_sec[battle_player_idx]/props.jsonBattles.duration_sec[i] * 100).toFixed(3)),
              playedTime: props.jsonBattlePlayer.playtime_sec[battle_player_idx],
              battleDuration: props.jsonBattles.duration_sec[i],
            });
          }

        }
        dataPlayerResign[battle_player_id].battleCount++;
        battle_player_idx++;
      }

      count_battles++;
    };

    return {dataPlayerResign:dataPlayerResign, count_battles:count_battles, playerBattleList:playerBattleList };
  };

  useEffect(() => {
    var processingStartTimeFirst = Date.now();
    if(Object.keys(filterBar).length>0) {

      const {dataPlayerResign, count_battles} =  computeDataPlayerResign(null);

      setMaximumGames(Math.max(...Object.keys(dataPlayerResign).map(Number).map((k)=>dataPlayerResign[k].battleCount)));
      setCountGames(count_battles);

      var rows:RowPlayerResignType[] = Object.keys(dataPlayerResign).map(Number).filter((p) => {
        return dataPlayerResign[p].battleCount>=minimumGamesDisplay &&
               (dataPlayerResign[p].teamWonWhenResigned + dataPlayerResign[p].teamLostWhenResigned) > 0;
      }).map((v) => {
        const p = dataPlayerResign[v];
        const idx = binary_search(props.jsonPlayers.player_id, v);

        var battles_resigned = (p.teamWonWhenResigned + p.teamLostWhenResigned);
        return {
          id: v,
          player: {
            id: v,
            nickname: props.jsonPlayers.nickname[idx],
          },
          teamWonWhenResigned: Number(Number(p.teamWonWhenResigned / battles_resigned * 100).toFixed(3)),
          teamLostWhenResigned: Number(Number(p.teamLostWhenResigned / battles_resigned * 100).toFixed(3)),
          overalResigned: Number(Number(battles_resigned / p.battleCount * 100).toFixed(3)),
          resignCount: battles_resigned,
          battleCount: p.battleCount,
          teamWonWhenResignedPercentageSum: Number(Number(p.teamWonWhenResignedPercentageSum / p.teamWonWhenResigned * 100).toFixed(3)),
          teamLostWhenResignedPercentageSum: Number(Number(p.teamLostWhenResignedPercentageSum / p.teamLostWhenResigned * 100).toFixed(3)),
        };
      })

      setRowsPlayerResign(rows);

      console.log("INFO: PlayerResign complete time "+(Date.now()-processingStartTimeFirst));
      return;
    }
  }, [filterBar, minimumGamesDisplay, props.jsonAwards, props.jsonBattlePlayer,
      props.jsonBattles, props.jsonGames, props.jsonMaps, props.jsonPlayers])

  useEffect(() => {
    setMinimumGamesDisplay(maximumGames*0.5);
  }, [maximumGames]);

  const gamesDisplaySet = useMemo(
    () =>
      throttle((value:number) => setMinimumGamesDisplay(value), 500),
    [],
  );

  // TODO: maybe these two should be moved as a property of filter bar
  var player_nickname = "";
  if(filterBar!==null) {
    const player_idx = props.jsonPlayers.player_id.findIndex((x)=>x===filterBar.playerId);
    player_nickname = props.jsonPlayers.nickname[player_idx];
  }

  // TODO: The & in the type does not make much ssense
  const showBattleList:GridEventListener<RowPlayerResignType & keyof GridEventLookup> = (params, event, details) => {
    if (!params) return;
    // TODO: check if the usage of as is ok
    const {playerBattleList} = computeDataPlayerResign((params as {id:number}).id);
    setModalData(playerBattleList);
    setModalOpen(true);
  };

  return (
    <div>
      <Stack spacing={2}>
        <Item>
          {props.children}
        </Item>
        <Item>
          <Stack direction="row" spacing={1}>
            <Item style={{ width: "100%" }}>

              <Stack direction="row" spacing={1}>
                <Item style={{ width: "50%" }}>
                  <Typography>
                    Resign statistics from {countGames} battles.
                  </Typography>
                  {player_nickname && <Typography>  Showing only battles in which player "{player_nickname}" played.</Typography>}
                  <Typography>
                    Note: hover over table heading to see options for sorting and column selection.
                  </Typography>
                  <Typography>
                    Note: double click on row in table to show battle list.
                  </Typography>
                </Item>
                <Item style={{ width: "50%" }}>
                  <Typography> Show only players with at least an amount of games played</Typography>
                  <Slider
                    onChange={(_, newValue) => { setMinimumGamesDisplay(newValue as number); gamesDisplaySet(newValue as number); } }
                    value={minimumGamesDisplay}
                    track={false}
                    step={1}
                    min={1}
                    max={maximumGames}
                    valueLabelDisplay="auto"
                  />
                </Item>
              </Stack>

              <div style={{ height: 600, width: '100%' }}>
               <DataGrid
                  rows={rowsPlayerResign}
                  columns={columnsPlayerResign}
                  onRowDoubleClick={showBattleList}
                />
             </div>
            </Item>
          </Stack>
        </Item>
        <Modal
          open={modalOpen}
          onClose={()=>{ setModalOpen(false); setModalData(null);} }
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Battle list for
            </Typography>
            {modalData &&
              <DataGrid
                 rows={modalData}
                 columns={columnsBattlesPlayerResign}
               />
            }
          </Box>
        </Modal>
      </Stack>
    </div>
  );
}

PlayerResign.propTypes = {
  jsonAwards: PropTypes.object,
  jsonBattles: PropTypes.object,
  jsonBattlePlayer: PropTypes.object,
  jsonGames: PropTypes.object,
  jsonMaps: PropTypes.object,
  jsonPlayers: PropTypes.object,
  filterBarValues: PropTypes.object,
};

export default PlayerResign;
